export * from './list';

import { ListComponent  } from './list';

export const ListOrganisms = [
    ListComponent
];